const routes = {
  about: '/about-us',
  activities: '/activities',
  article: 'articles',
  cards: 'cards',
  certificateSettings: '/certificate-settings',
  certification: '/courses/:courseId/certification',
  course: '/courses/:courseId',
  courses: '/courses',
  deleteProfile: '/delete-profile',
  learningMap: '/learning-map',
  mainPage: '/',
  module: '/courses/:courseId/:moduleId',
  offlineContent: '/offline-content',
  onboarding: '/courses/onboarding',
  privacyPolicy: '/privacy',
  profile: '/profile',
  scenario: 'scenarios',
  settings: '/settings',
  termsOfService: '/terms',
  test: 'tests',
};

export { routes };
